module.exports = __webpack_public_path__ + "static/media/pepinos.b3042ac4.png";